export const featuresData = [
  {
    year: 2015,
    tagline: "3D Touch debuts, Watch apps go native, Swift hits 2.0",
    sections: {
      "OS": [
        { name: "iOS 9\nOS X 10.11 (El Capitan)\ntvOS 9\nwatchOS 2", platform: ["iOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "3D Touch / Force Touch", platform: ["iOS"], category: "Input", status: "deprecated", note: "Removed in iOS 13, replaced by Haptic Touch" },
        { name: "Digital Crown Input", platform: ["watchOS"], category: "Input" },
        { name: "Heart Rate Sensor", platform: ["watchOS"], category: "Health" },
        { name: "Taptic Engine", platform: ["watchOS"], category: "Input" }
      ],
      "Frameworks & APIs": [
        { name: "ClockKit Complications", platform: ["watchOS"], category: "Widgets", keyword: "clockkit" },
        { name: "CoreSpotlight", platform: ["iOS"], category: "System", keyword: "corespotlight" },
        { name: "Live Photos APIs (PHLivePhoto)", platform: ["iOS"], category: "Media", keyword: "phlivephoto" },
        { name: "ReplayKit", platform: ["iOS"], category: "Media", keyword: "replaykit" },
        { name: "Safari Content Blocking", platform: ["iOS"], category: "System", keyword: "safari+content+blocking" },
        { name: "Top Shelf (TVTopShelfProvider)", platform: ["tvOS"], category: "System", keyword: "tvtopshelfprovider" }
      ],
      "User facing features": [
        { name: "Apple TV App Store", platform: ["tvOS"], category: "System" },
        { name: "Native Apple Watch Apps", platform: ["watchOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 7", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Swift 2.0", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System" },
        { name: "App Thinning", platform: ["iOS"], category: "System", url: "https://developer.apple.com/documentation/xcode/reducing-your-app-s-size" }
      ]
    }
  },
  {
    year: 2016,
    tagline: "Messages becomes a platform, Siri opens up, CallKit rings in",
    sections: {
      "OS": [
        { name: "iOS 10\nmacOS 10.12 (Sierra)\ntvOS 10\nwatchOS 3", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Handwriting Recognition (Scribble)", platform: ["watchOS"], category: "Input" },
        { name: "Haptic Feedback (Taptic Engine Gen 2)", platform: ["iOS"], category: "Input" },
        { name: "Live Photos Editing", platform: ["iOS"], category: "Media" }
      ],
      "Frameworks & APIs": [
        { name: "Activity Sharing", platform: ["watchOS"], category: "Health", keyword: "activity+sharing" },
        { name: "Background App Refresh", platform: ["watchOS"], category: "System", keyword: "background+app+refresh" },
        { name: "CallKit", platform: ["iOS"], category: "Communication", keyword: "callkit" },
        { name: "Live Photos Editing (PHLivePhotoEditingContext)", platform: ["iOS"], category: "Media", keyword: "phlivephotoeditingcontext" },
        { name: "Messages Framework (iMessage Apps)", platform: ["iOS"], category: "Communication", keyword: "messages+framework" },
        { name: "SiriKit", platform: ["iOS"], category: "AI/ML", keyword: "sirikit" },
        { name: "Speech Recognition", platform: ["iOS"], category: "AI/ML", keyword: "speech" },
        { name: "UIFeedbackGenerator", platform: ["iOS"], category: "Input", keyword: "uifeedbackgenerator" },
        { name: "UserNotifications", platform: ["iOS"], category: "System", keyword: "user+notifications" },
        { name: "VideoSubscriberAccount (Single Sign-On)", platform: ["tvOS"], category: "System", keyword: "videosubscriberaccount" }
      ],
      "User facing features": [
        { name: "Apple Watch Dock", platform: ["watchOS"], category: "System" },
        { name: "Scribble (Handwriting)", platform: ["watchOS"], category: "Input" }
      ],
      "Tools & Languages": [
        { name: "Xcode 8", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Swift 3.0", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-3.0-released/" },
        { name: "Swift Package Manager", platform: ["macOS"], category: "System" },
        { name: "Swift Playgrounds", platform: ["iOS", "macOS"], category: "System" }
      ]
    }
  },
  {
    year: 2017,
    tagline: "ARKit launches, Face ID lands, Machine Learning arrives",
    sections: {
      "OS": [
        { name: "iOS 11\nmacOS 10.13 (High Sierra)\ntvOS 11\nwatchOS 4", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Background Audio", platform: ["iOS", "watchOS"], category: "Media" },
        { name: "GymKit", platform: ["watchOS"], category: "Health" },
        { name: "NFC Reader", platform: ["iOS"], category: "System" },
        { name: "TrueDepth Camera (Face Tracking)", platform: ["iOS"], category: "AR/Spatial" }
      ],
      "Frameworks & APIs": [
        { name: "ARKit 1.0", platform: ["iOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "CoreML", platform: ["iOS"], category: "AI/ML", keyword: "coreml" },
        { name: "Core NFC", platform: ["iOS"], category: "System", keyword: "core+nfc" },
        { name: "Drag and Drop", platform: ["iOS"], category: "Input", keyword: "drag+drop" },
        { name: "MusicKit", platform: ["iOS"], category: "Media", keyword: "musickit" },
        { name: "PDFKit", platform: ["iOS"], category: "Media", keyword: "pdfkit" },
        { name: "SiriKit Lists and Notes", platform: ["watchOS"], category: "AI/ML", keyword: "sirikit" },
        { name: "UIDocumentBrowserViewController (Files)", platform: ["iOS"], category: "System", keyword: "uidocumentbrowserviewcontroller" },
        { name: "Vision Framework", platform: ["iOS"], category: "AI/ML", keyword: "vision+framework" }
      ],
      "User facing features": [
        { name: "Animoji", platform: ["iOS"], category: "AR/Spatial" },
        { name: "Files App", platform: ["iOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 9", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Swift 4.0", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-4.0-released/" },
        { name: "CoreML Tools", platform: ["macOS"], category: "AI/ML", url: "https://developer.apple.com/documentation/coreml/" }
      ]
    }
  },
  {
    year: 2018,
    tagline: "Shortcuts automate workflows, Siri gets smarter with suggestions, Screen Time brings awareness",
    sections: {
      "OS": [
        { name: "iOS 12\nmacOS 10.14 (Mojave)\ntvOS 12\nwatchOS 5", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Automatic Workout Detection", platform: ["watchOS"], category: "Health" },
        { name: "Dolby Atmos Support", platform: ["tvOS"], category: "Media" },
      ],
      "Frameworks & APIs": [
        { name: "Activity Competitions", platform: ["watchOS"], category: "Health", keyword: "activity+competitions" },
        { name: "ARKit 2 (Persistent AR, Shared Experiences)", platform: ["iOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "CoreML 2", platform: ["iOS"], category: "AI/ML", keyword: "coreml" },
        { name: "Create ML", platform: ["iOS", "macOS"], category: "AI/ML", keyword: "createml" },
        { name: "Group FaceTime", platform: ["iOS"], category: "Communication", keyword: "group+facetime" },
        { name: "Grouped Notifications", platform: ["iOS"], category: "System", keyword: "grouped+notifications" },
        { name: "Interactive Notifications", platform: ["watchOS"], category: "System", keyword: "interactive+notifications" },
        { name: "Password Rules (UITextInputPasswordRules)", platform: ["iOS"], category: "Authentication", keyword: "uitextinputpasswordrules" },
        { name: "Podcasts APIs", platform: ["watchOS"], category: "Media", keyword: "podcasts+api" },
        { name: "Siri Shortcuts", platform: ["iOS"], category: "AI/ML", keyword: "shortcuts" },
        { name: "SMS AutoFill (UITextContentType.oneTimeCode)", platform: ["iOS"], category: "Authentication", keyword: "uitextcontenttype" },
        { name: "WebKit support", platform: ["watchOS"], category: "System", keyword: "webkit" }
      ],
      "User facing features": [
        { name: "Memoji", platform: ["iOS"], category: "AR/Spatial" },
        { name: "Password AutoFill", platform: ["iOS"], category: "Authentication" },
        { name: "Shortcuts App", platform: ["iOS"], category: "System" },
        { name: "Screen Time (DeviceActivity)", platform: ["iOS"], category: "System" },
        { name: "Walkie-Talkie", platform: ["watchOS"], category: "Communication" }
      ],
      "Tools & Languages": [
        { name: "Xcode 10", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Swift 4.2", platform: ["iOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-4.2-released/" },
        { name: "Create ML Tools", platform: ["iOS", "macOS"], category: "AI/ML" }
      ]
    }
  },
  {
    year: 2019,
    tagline: "SwiftUI, Combine, Dark Mode arrives, Sign In with Apple",
    sections: {
      "OS": [
        { name: "iOS 13\niPadOS 13\nmacOS 10.15 (Catalina)\ntvOS 13\nwatchOS 6", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Audio Sharing", platform: ["iOS", "iPadOS"], category: "Media" },
        { name: "Mouse & Trackpad Support", platform: ["iPadOS"], category: "Input" }
      ],
      "Frameworks & APIs": [
        { name: "ARKit 3 (People Occlusion, Motion Capture)", platform: ["iOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "Combine Framework", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System", keyword: "combine" },
        { name: "Core Haptics", platform: ["iOS"], category: "Input", keyword: "core+haptics" },
        { name: "CoreML 3", platform: ["iOS"], category: "AI/ML", keyword: "coreml" },
        { name: "Custom Fonts API", platform: ["iOS", "iPadOS"], category: "System", keyword: "custom+fonts+api" },
        { name: "Cycle Tracking", platform: ["watchOS"], category: "Health", keyword: "cycle+tracking" },
        { name: "Dark Mode (UITraitCollection)", platform: ["iOS", "iPadOS"], category: "System", keyword: "dark+mode" },
        { name: "Mouse & Trackpad Support (Assistive Touch)", platform: ["iPadOS"], category: "Input", keyword: "mouse+trackpad+support" },
        { name: "Multiple Windows (UIScene)", platform: ["iPadOS"], category: "System", keyword: "uiscene" },
        { name: "PencilKit", platform: ["iOS", "iPadOS"], category: "Drawing", keyword: "pencilkit" },
        { name: "RealityKit", platform: ["iOS"], category: "AR/Spatial", keyword: "realitykit" },
        { name: "Sign in with Apple", platform: ["iOS", "iPadOS"], category: "Authentication", keyword: "sign+in+with+apple" },
        { name: "Streaming Audio", platform: ["watchOS"], category: "Media", keyword: "streaming+audio" },
        { name: "SwiftUI", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", keyword: "swiftui" },
        { name: "UIContextMenuInteraction (Contextual Menus)", platform: ["iOS", "iPadOS", "tvOS", "visionOS"], category: "System", keyword: "uicontextmenuinteraction" },
        { name: "VisionKit", platform: ["iOS", "iPadOS", "macOS", "visionOS"], category: "AI/ML", keyword: "VisionKit" },
      ],
      "User facing features": [
        { name: "Always-On Display", platform: ["watchOS"], category: "System" },
        { name: "Apple Arcade", platform: ["iOS", "iPadOS", "macOS", "tvOS"], category: "System" },
        { name: "Independent Watch App Store", platform: ["watchOS"], category: "System" },
        { name: "iPadOS (Platform Split)", platform: ["iPadOS"], category: "System" },
        { name: "Multi-User Support (tvOS)", platform: ["tvOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 11", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 5.1", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-5.1-released/" },
        { name: "SwiftUI Previews", platform: ["macOS"], category: "System" }
      ]
    }
  },
  {
    year: 2020,
    tagline: "Widgets redesign the Home Screen, App Clips launch, LiDAR Scanner",
    sections: {
      "OS": [
        { name: "iOS 14\niPadOS 14\nmacOS 11 (Big Sur)\ntvOS 14\nwatchOS 7", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Automatic Handwashing Detection", platform: ["watchOS"], category: "Health" },
        { name: "Back Tap", platform: ["iOS"], category: "Input" },
        { name: "Car Key", platform: ["iOS"], category: "System" },
        { name: "LiDAR Scanner", platform: ["iOS", "iPadOS"], category: "AR/Spatial" },
        { name: "New Workout Types (Dance, Functional Strength)", platform: ["watchOS"], category: "Health" },
        { name: "Shape Recognition", platform: ["iOS", "iPadOS"], category: "AI/ML" },
        { name: "Sleep Tracking", platform: ["watchOS"], category: "Health" }
      ],
      "Frameworks & APIs": [
        { name: "App Clips", platform: ["iOS", "iPadOS"], category: "System", keyword: "app+clips" },
        { name: "ARKit 4 (Depth API, Location Anchors)", platform: ["iOS", "iPadOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "Multiple Complications from Same App", platform: ["watchOS"], category: "Widgets", keyword: "multiple+watchos+complications" },
        { name: "Noise API", platform: ["watchOS"], category: "Health", keyword: "environmentalAudioExposureEvent" },
        { name: "Picture in Picture (System-wide)", platform: ["iOS", "iPadOS"], category: "Media", keyword: "picture+in+picture" },
        { name: "Scribble (in PencilKit)", platform: ["iPadOS"], category: "Drawing", keyword: "PencilKit" },
        { name: "Watch Face Sharing", platform: ["watchOS"], category: "Widgets", keyword: "watch+face+sharing" },
        { name: "WidgetKit", platform: ["iOS", "iPadOS"], category: "Widgets", keyword: "widgetkit" }
      ],
      "User facing features": [
        { name: "App Library", platform: ["iOS"], category: "System" },
        { name: "Back Tap", platform: ["iOS"], category: "Input" }
      ],
      "Tools & Languages": [
        { name: "Xcode 12", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols 2", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 5.3", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-5.3-released/" },
      ]
    }
  },
  {
    year: 2021,
    tagline: "FaceTime gets SharePlay, Focus filters distractions, Spatial Audio arrives",
    sections: {
      "OS": [
        { name: "iOS 15\niPadOS 15\nmacOS 12 (Monterey)\ntvOS 15\nwatchOS 8", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Sleep Tracking Enhancements", platform: ["watchOS"], category: "Health" },
        { name: "Spatial Audio for FaceTime", platform: ["iOS", "macOS", "iPadOS"], category: "Media" }
      ],
      "Frameworks & APIs": [
        { name: "Focus Mode API", platform: ["iOS", "iPadOS", "macOS", "watchOS"], category: "System", keyword: "focus+mode+api" },
        { name: "Live Text (VisionKit)", platform: ["iOS", "iPadOS"], category: "AI/ML", keyword: "visionkit" },
        { name: "Multiple Timers", platform: ["watchOS"], category: "System", keyword: "multiple+timers" },
        { name: "Pilates & Tai Chi Workouts", platform: ["watchOS"], category: "Health", keyword: "pilates+tai+chi" },
        { name: "Respiratory Rate Tracking", platform: ["watchOS"], category: "Health", keyword: "respiratory+rate" },
        { name: "SharePlay (GroupActivities)", platform: ["iOS", "iPadOS", "macOS", "tvOS"], category: "Communication", keyword: "shareplay" },
        { name: "StoreKit 2", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", keyword: "storekit" }
      ],
      "User facing features": [
        { name: "Always-On Display (Third-Party Apps)", platform: ["watchOS"], category: "System" },
        { name: "Focus Modes", platform: ["iOS", "iPadOS", "macOS", "watchOS"], category: "System" },
        { name: "Notification Summary", platform: ["iOS", "iPadOS"], category: "System" },
        { name: "Shortcuts for Mac", platform: ["macOS"], category: "Productivity" },
        { name: "Spatial Audio for FaceTime", platform: ["iOS", "iPadOS", "macOS"], category: "Media" }
      ],
      "Tools & Languages": [
        { name: "Xcode 13", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Xcode Cloud", platform: ["macOS"], category: "Developer Tools" },
        { name: "SF Symbols 3", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 5.5", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-5.5-released/" },
        { name: "Async / Await Concurrency", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System" },
        { name: "DocC (Documentation Compiler)", platform: ["macOS"], category: "Developer Tools" }
      ]
    }
  },
  {
    year: 2022,
    tagline: "Dynamic Island debuts, Lock Screen customization, Always-On Display",
    sections: {
      "OS": [
        { name: "iOS 16\niPadOS 16\nmacOS 13 (Ventura)\ntvOS 16\nwatchOS 9", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System" }
      ],
      "Device capability": [
        { name: "AFib History", platform: ["watchOS"], category: "Health" },
        { name: "Always-On Display", platform: ["iOS"], category: "System" },
        { name: "Dynamic Island", platform: ["iOS"], category: "System" },
        { name: "Nintendo Switch Controller Support", platform: ["iOS", "macOS", "tvOS", "iPadOS"], category: "Input" },
        { name: "Photo Cutout/Visual Lookup", platform: ["iOS", "macOS", "iPadOS"], category: "AI/ML" },
        { name: "Reference Mode", platform: ["iPadOS"], category: "Media" },
        { name: "Sleep Stages", platform: ["watchOS"], category: "Health" }
      ],
      "Frameworks & APIs": [
        { name: "App Intents Framework", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", keyword: "app+intents" },
        { name: "DataScannerViewController", platform: ["iOS", "iPadOS"], category: "AI/ML", keyword: "datascannerviewcontroller" },
        { name: "Live Activities (ActivityKit)", platform: ["iOS"], category: "Widgets", keyword: "activitykit" },
        { name: "Lock Screen Widgets", platform: ["iOS"], category: "Widgets", keyword: "lock+screen+widgets" },
        { name: "NavigationSplitView", platform: ["watchOS"], category: "System", keyword: "navigationsplitview" },
        { name: "Passkeys", platform: ["iOS", "iPadOS", "macOS"], category: "Authentication", url: "https://developer.apple.com/documentation/authenticationservices/connecting-to-a-service-with-passkeys" },
        { name: "RoomPlan", platform: ["iOS", "iPadOS", "macOS"], category: "AR/Spatial", keyword: "roomplan" },
        { name: "Swift Charts", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", keyword: "swift+charts" },
        { name: "WeatherKit", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", keyword: "weatherkit" }
      ],
      "User facing features": [
        { name: "Customizable Lock Screen", platform: ["iOS"], category: "System" },
        { name: "Stage Manager", platform: ["iPadOS"], category: "System" },
        { name: "Weather App for iPad", platform: ["iPadOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 14", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols 4", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 5.7", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS"], category: "System", url: "https://www.swift.org/blog/swift-5.7-released/" },
        { name: "Swift Package Plugins", platform: ["macOS"], category: "System" }
      ]
    }
  },
  {
    year: 2023,
    tagline: "StandBy mode, Interactive Widgets, Vision Pro announcement",
    sections: {
      "OS": [
        { name: "iOS 17\niPadOS 17\nmacOS 14 (Sonoma)\ntvOS 17\nvisionOS 1\nwatchOS 10", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Action Button", platform: ["iOS"], category: "Input" },
        { name: "Bluetooth Direct Connection", platform: ["watchOS"], category: "System" },
        { name: "Enhanced Keyboard and Autocorrection", platform: ["iOS", "iPadOS"], category: "Input" },
        { name: "FaceTime via Continuity Camera", platform: ["macOS"], category: "Communication" },
        { name: "Live Voicemail", platform: ["iOS"], category: "Communication" },
        { name: "Smart Stack Widgets", platform: ["watchOS"], category: "Widgets" }
      ],
      "Frameworks & APIs": [
        { name: "Background Health Data Access", platform: ["watchOS"], category: "Health", keyword: "background+health+data" },
        { name: "Contact Posters (CallKit)", platform: ["iOS"], category: "Communication", keyword: "CallKit" },
        { name: "HealthKit on iPad", platform: ["iPadOS"], category: "Health", keyword: "healthkit" },
        { name: "Interactive Widgets", platform: ["iOS", "iPadOS"], category: "Widgets", url: "https://developer.apple.com/documentation/widgetkit/adding-interactivity-to-widgets-and-live-activities" },
        { name: "Journaling Suggestions API", platform: ["iOS", "iPadOS"], category: "AI/ML", keyword: "journaling+suggestions" },
        { name: "Observation Framework", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System", keyword: "observation" },
        { name: "SwiftData", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System", keyword: "swiftdata" },
        { name: "TipKit", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System", keyword: "tipkit" },
        { name: "WorkoutKit", platform: ["iOS", "iPadOS", "watchOS"], category: "Health", keyword: "workoutkit" }
      ],
      "User facing features": [
        { name: "Apple Vision Pro Launch", platform: ["visionOS"], category: "System" },
        { name: "Check In (Messages)", platform: ["iOS"], category: "Communication" },
        { name: "Journal App", platform: ["iOS"], category: "System" },
        { name: "NameDrop", platform: ["iOS"], category: "System" },
        { name: "StandBy Mode", platform: ["iOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 15", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols 5", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 5.9", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System", url: "https://www.swift.org/blog/swift-5.9-released/" },
      ]
    }
  },
  {
    year: 2024,
    tagline: "Apple Intelligence arrives, Visual Intelligence, Passwords app",
    sections: {
      "OS": [
        { name: "iOS 18\niPadOS 18\nmacOS 15 (Sequoia)\ntvOS 18\nvisionOS 2\nwatchOS 11", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Camera Control Button", platform: ["iOS"], category: "Input" },
        { name: "Enhanced Dialogue Clarity", platform: ["tvOS"], category: "Media" },
        { name: "Game Mode", platform: ["iOS", "macOS", "iPadOS"], category: "System" },
        { name: "Hand Tracking Enhancements", platform: ["visionOS"], category: "Input" },
        { name: "Visual Intelligence", platform: ["iOS"], category: "AI/ML" }
      ],
      "Frameworks & APIs": [
        { name: "Apple Projected Media Profile (APMP)", platform: ["visionOS"], category: "Media", keyword: "Apple+Projected+Media+Profile" },
        { name: "ARKit for visionOS", platform: ["visionOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "Controls API", platform: ["iOS", "iPadOS"], category: "System", keyword: "ControlCenter" },
        { name: "Genmoji API", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML", keyword: "genmoji" },
        { name: "Image Playground API", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML", keyword: "image+playground" },
        { name: "Portal Crossing", platform: ["iOS", "iPadOS", "macOS", "tvOS", "visionOS"], category: "AR/Spatial", keyword: "portal+crossing+component" },
        { name: "RealityKit 4", platform: ["iOS", "iPadOS", "macOS", "visionOS"], category: "AR/Spatial", keyword: "realitykit" },
        { name: "Spatial Audio Components", platform: ["iOS", "iPadOS", "macOS", "tvOS", "visionOS"], category: "Media", keyword: "spatial+audio" },
        { name: "Writing Tools API", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML", keyword: "writing+tools" }
      ],
      "User facing features": [
        { name: "Apple Intelligence", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML" },
        { name: "Calculator App for iPad", platform: ["iPadOS"], category: "System" },
        { name: "iPhone Mirroring (Continuity)", platform: ["iOS", "macOS"], category: "System" },
        { name: "Passwords App", platform: ["iOS", "iPadOS", "macOS"], category: "Authentication" }
      ],
      "Tools & Languages": [
        { name: "Xcode 16", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols 6", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 6.0", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System", url: "https://www.swift.org/blog/announcing-swift-6/" },
      ]
    }
  },
  {
    year: 2025,
    tagline: "Liquid Glass redesign, Year-based OS versioning arrives",
    sections: {
      "OS": [
        { name: "iOS 26\niPadOS 26\nmacOS 26 (Tahoe)\ntvOS 26\nvisionOS 26\nwatchOS 26", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System" }
      ],
      "Device capability": [
        { name: "Live Translation", platform: ["iOS", "iPadOS", "watchOS"], category: "AI/ML" },
        { name: "Visual Intelligence Enhancements", platform: ["iOS"], category: "AI/ML" },
        { name: "Wrist Flick Gesture", platform: ["watchOS"], category: "Input" },
        { name: "Hypertension Notifications", platform: ["watchOS"], category: "Health" },
        { name: "Sleep Score", platform: ["watchOS"], category: "Health" }
      ],
      "Frameworks & APIs": [
        { name: "AlarmKit", platform: ["iOS", "iPadOS"], category: "System", keyword: "alarmkit" },
        { name: "Controls on macOS", platform: ["macOS"], category: "System", keyword: "controls+macos" },
        { name: "Enhanced Siri with Personal Context", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML", keyword: "SiriKit" },
        { name: "Foundation Models (3B parameters)", platform: ["iOS", "iPadOS", "macOS", "visionOS"], category: "AI/ML", keyword: "foundation+models" },
        { name: "Image Presentation Component", platform: ["visionOS"], category: "Media", keyword: "image+presentation+component" },
        { name: "Immersive Media Support Framework", platform: ["macOS", "visionOS"], category: "Media", keyword: "immersive+media" },
        { name: "Liquid Glass Material APIs", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System", keyword: "liquid+glass" },
        { name: "Live Activities on macOS", platform: ["macOS"], category: "Widgets", keyword: "live+activities" },
        { name: "Medications API", platform: ["watchOS"], category: "Health", keyword: "HKUserAnnotatedMedication" },
        { name: "Observable Entity & Animations", platform: ["visionOS"], category: "AR/Spatial", keyword: "observable+entity" },
        { name: "WidgetKit Enhancements (Glass, Push Updates, CarPlay, visionOS)", platform: ["iOS", "iPadOS", "macOS", "watchOS", "visionOS"], category: "Widgets", url: "https://developer.apple.com/documentation/widgetkit" }
      ],
      "User facing features": [
        { name: "Liquid Glass Design Language", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System" },
        { name: "New iPad Windowing System", platform: ["iPadOS"], category: "System" },
        { name: "Year-Based Versioning (iOS 26)", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 26", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "SF Symbols 7", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "Swift 6.2", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System", url: "https://developer.apple.com/swift/" },
        { name: "AI Code Generation", platform: ["macOS"], category: "AI/ML", url: "https://developer.apple.com/documentation/xcode/writing-code-with-intelligence-in-xcode/" }
      ]
    }
  },
  {
    year: 2026,
    tagline: "Siri AI reboots the assistant, Foundation Models opens to third-party models, iPhone Duo folds the canvas in two",
    sections: {
      "OS": [
        { name: "iOS 27\niPadOS 27\nmacOS 27 (Golden Gate)\ntvOS 27\nvisionOS 27\nwatchOS 27", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System" }
      ],
      "Device capability": [
        { name: "iPhone Duo (Foldable, 5.4\" Outer / 7.6\" Inner OLED)", platform: ["iOS"], category: "System" },
        { name: "A20 Pro (2nm) & C2 Modem", platform: ["iOS"], category: "System" },
        { name: "Siri AI On-Device Models (iPhone 15 Pro and later)", platform: ["iOS", "iPadOS", "macOS", "watchOS", "visionOS"], category: "AI/ML" },
        { name: "Health Sensing System (S11, Series 12 / Ultra 4)", platform: ["watchOS"], category: "Health" },
        { name: "Heart Rate & Cycling Power Zones", platform: ["watchOS"], category: "Health" },
        { name: "Dynamic App Grid", platform: ["watchOS"], category: "System" },
        { name: "Tap Gesture (Apple Watch)", platform: ["watchOS", "iOS"], category: "Input" },
        { name: "Apple Vision Pro (M5, 90Hz Hand Tracking)", platform: ["visionOS"], category: "AR/Spatial" },
        { name: "GymKit on iPhone and AirPods Pro 3", platform: ["iOS"], category: "Health" }
      ],
      "Frameworks & APIs": [
        { name: "Foundation Models (LanguageModel Protocol, Dynamic Profiles, Image Input)", platform: ["iOS", "iPadOS", "macOS", "visionOS", "watchOS"], category: "AI/ML", keyword: "foundation+models" },
        { name: "Core AI Framework", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML", keyword: "core+ai" },
        { name: "App Intents App/Entity/Intent Schemas", platform: ["iOS", "iPadOS", "macOS", "watchOS", "visionOS"], category: "AI/ML", keyword: "app+intents" },
        { name: "ArrangementView (iPhone Duo Adaptive Layout)", platform: ["iOS", "iPadOS"], category: "System", keyword: "arrangementview" },
        { name: "ReservedRegion / UIViewReservedRegion", platform: ["iOS", "iPadOS"], category: "System", keyword: "reservedregion" },
        { name: "Hinge API (onHingeChange, UIHingeInteraction)", platform: ["iOS"], category: "Input", keyword: "uihingeinteraction" },
        { name: "Image Playground on Private Cloud Compute", platform: ["iOS", "iPadOS", "macOS", "visionOS"], category: "AI/ML", keyword: "imageplaygroundsheet" },
        { name: "ImageCreator", platform: ["iOS", "iPadOS", "macOS", "visionOS"], category: "AI/ML", keyword: "imagecreator", status: "deprecated", note: "Deprecated in iOS 27 — replaced by Image Playground's .imagePlaygroundSheet / ImagePlaygroundViewController" },
        { name: "RealityKit (Gaussian Splatting, Cloth Simulation)", platform: ["visionOS", "iOS", "iPadOS", "macOS"], category: "AR/Spatial", keyword: "realitykit" },
        { name: "Spatial Accessories Framework", platform: ["visionOS"], category: "AR/Spatial", keyword: "spatial+accessories" },
        { name: "Spatial Preview & Foveated Streaming", platform: ["visionOS", "macOS"], category: "AR/Spatial", keyword: "spatial+preview" },
        { name: "ARKit Cross-Platform Object Tracking", platform: ["iOS", "visionOS"], category: "AR/Spatial", keyword: "arkit" },
        { name: "SwiftUI Reorderable Containers & WritableDocument", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS", "visionOS"], category: "System", keyword: "swiftui" },
        { name: "HealthKit Perimenopause & Menopause API", platform: ["iOS", "watchOS"], category: "Health", keyword: "healthkit" }
      ],
      "User facing features": [
        { name: "Siri AI (Conversational, On-Screen Awareness)", platform: ["iOS", "iPadOS", "macOS", "watchOS", "visionOS"], category: "AI/ML" },
        { name: "Dedicated Siri App", platform: ["iOS", "iPadOS", "macOS"], category: "AI/ML" },
        { name: "Audio Intelligence (Live Rewind, Siri Recap, Sound Recognition)", platform: ["watchOS"], category: "AI/ML" },
        { name: "Readiness Score & Health Age", platform: ["watchOS", "iOS"], category: "Health" },
        { name: "Child Accounts & Parental Controls", platform: ["iOS", "iPadOS", "macOS"], category: "System" },
        { name: "iCloud Shared Albums (Cross-Platform)", platform: ["iOS", "iPadOS", "macOS"], category: "Media" },
        { name: "macOS Golden Gate Design Refresh", platform: ["macOS"], category: "System" }
      ],
      "Tools & Languages": [
        { name: "Xcode 27 (Apple Silicon Only, Device Hub)", platform: ["macOS"], category: "System", url: "https://developer.apple.com/xcode/" },
        { name: "Swift 6.4", platform: ["iOS", "macOS", "iPadOS", "watchOS", "tvOS", "visionOS"], category: "System", url: "https://www.swift.org/blog/" },
        { name: "SF Symbols 27", platform: ["iOS", "iPadOS", "macOS", "watchOS", "tvOS"], category: "System", url: "https://developer.apple.com/sf-symbols/" },
        { name: "MLX (Metal 4, Multi-Mac Training)", platform: ["macOS"], category: "AI/ML" }
      ]
    }
  }
];
